// Module
var code = `<div id="back-to-top"> <i class="fa fa-angle-double-up" aria-hidden="true" ng-click="backToTopController.scroll()"></i> </div> `;
// Exports
module.exports = code;